import type { OperationsSnapshot } from "../admin/operations";

export function isOperationsSnapshot(
  value: unknown,
): value is OperationsSnapshot {
  if (typeof value !== "object" || value === null) return false;
  const row = value as Record<string, unknown>;
  return (
    typeof row.telegram_state === "string" &&
    typeof row.incident_count === "number" &&
    typeof row.outbox_lag_seconds === "number" &&
    typeof row.active_jobs === "number" &&
    typeof row.release_version === "string"
  );
}
